import React from "react";
import { AddPodcastCategoryHomeSectionModalTemplate } from "themes/administration/naki-mobile/components";

function AddPodcastCategoryHomeSectionModal(props) {
    return <AddPodcastCategoryHomeSectionModalTemplate {...props} />;
}

export default AddPodcastCategoryHomeSectionModal;
